import useRecommenderWorkspaceStore from '@store/RecommenderWorkspaceStore';
import { FormMetadata } from '../components/common/interfaces';
import { FormNames } from '@youscience/commonapp-service-common';
import { getFormsMetadata } from '../components/common/formUtils';
import { useEffect, useState } from 'react';

export const useApplicantFormsMetadata = () => {
  const { applicant } = useRecommenderWorkspaceStore((store) => store);

  const [formsMetadata, setFormsMetadata] = useState<Record<FormNames, FormMetadata>>(
    {} as Record<FormNames, FormMetadata>,
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setFormsMetadata({} as Record<FormNames, FormMetadata>);
    setIsLoading(true);

    if (!applicant) {
      setIsLoading(false);
      return;
    }

    const newFormsMetadata = getFormsMetadata(applicant);
    setFormsMetadata(newFormsMetadata);
    setIsLoading(false);
  }, [applicant]);

  return { formsMetadata, isLoading };
};
